define(function (require, exports, module) {
    var classifier = require('es6ish-class/es6ish-class');
    var dataFetcher = require('data-fetcher/data-fetcher');
    var FileRequestItem = require('../execute/FileRequestItem');
    var Config = require('../../utils/HeartbeatConfig');
    var TfsManager = require('../../control/TfsManager');
    var extend = require('datasource-manager/lib/extend');

    function BaseHeartbeatItem (id, gameItem) {
        var that = this;
        this.gameRef = id;
        this.gameItem = gameItem;
        this.params = {};
        this.loadCnt = 0;
        this.partialLoadCnt = 0;
        this.intervalId = -1;
        this.firstRun = true;
        this.lastCall = this.timecode();
        this.active = false;
        this.paused = false;
        this.initComplete = false;
        this.secondHelping = false;
        this.locale = Config.locale || 'en';
        this.apiSite = Config.apiSite || 'en';
        this.fileUnderLang = this.locale !== 'en' ? ('_' + this.locale) : '';

        this.checkHeartbeatCallback = function () {
            that.checkHeartbeat();
        };
        this.storeCallback = function (response) {
            return that.store(response);
        };
    }

    BaseHeartbeatItem.prototype = {
        liveRefreshTimer: 10,
        postGameRefreshTimer: 30,
        timecode: function (date) {
            return (date || new Date()).getTime();
        },
        addGameParams: function (overrides) {
            var gid = this.gameItem.gid;
            var tfs = this.tfs || {};
            var pushUpdateId = !!this.pushUpdateId ? `&pushUpdateId=${this.pushUpdateId}`: '';
            var params = {
                'yyyy': gid.year,
                'mm': gid.month,
                'dd': gid.day,
                'gid': gid.displayVal,
                'sportcode': gid.home_sport_code,
                timecode: tfs.params,
                startTimecode: tfs.startTimecode,
                endTimecode: tfs.endTimecode,
                site: this.apiSite,
                locale: this.locale,
                underLang: this.fileUnderLang,
                pushUpdateId: pushUpdateId
            };

            return extend(params, overrides);
        },
        setParams: function (pars) {
            this.params = this.addGameParams(pars);
        },

        setTfsParams: function () {
            var tfs = this.tfs = TfsManager.getCurrentTimecode(this.secondHelping, this.previousTimecode);
            this.tfsTimecode = tfs.params;
        },

        init: function () {
            this.setParams();
        },
        // Start the heartbeat
        // Data updates are active.
        // Connect to timing sources, or wait for timecodes.
        start: function () {
            this.active = true;
            this.paused = false;
            return this.checkHeartbeat();
        },
        // Stop the heartbeat entirely
        // Data updates are not allowed without reviving
        // the system and reactivating.
        // Disconnect from all timing sources.
        stop: function () {
            this.active = false;
            this.paused = false;
            // Clear interval and reset
            this.cancel();
            this.intervalId = -1;
        },
        // Stop the heartbeat, but enter a paused state
        // indicating data updates are still allowed
        // but we are not expected to connect to timing sources
        // We may accept timecodes.
        pause: function () {
            this.stop();
            this.paused = true;
        },
        checkHeartbeat: function () {
            if (!this.active) {
                return true;
            }
            this.setGameState();

            var lastCallMade = this.timecode() - this.lastCall;
            var wait = this.gamestate === 'final' ? this.postGameRefreshTimer : this.liveRefreshTimer;
            var waitms = wait * 1000;
            var nextTick = lastCallMade >= waitms ? waitms : Math.max(waitms - lastCallMade, 1000);

            // In post game? Up refresh time to 60 seconds. Otherwise, use regular timer
            Config.wait = wait;

            this.tick(this.checkHeartbeatCallback, nextTick);

            if (lastCallMade > waitms) {
                this.executeHeartbeat();
                return true;
            }
            return false;
        },
        executeHeartbeat: function () {
            this.lastCall = this.timecode();
            this.setTfsParams();
        },
        setGameState: function () {
            // placeholder unless implemented by child
        },
        fetch: function (dataSourceName, refresh, params) {
            // Merged passed in params and instance params (avoid overwriting)
            var mergedParams = extend({}, this.params, params);
            // fetch data requested, call callback, if passed in. Store data using proper method.
            return dataFetcher.get(new FileRequestItem(dataSourceName, refresh, mergedParams));
        },
        fetchAndStore: function (dataSourceName, refresh, params) {
            return this.fetch(dataSourceName, refresh, params).then(this.storeCallback, this.storeCallback);
        },
        isActive: function () {
            return this.active;
        },
        cancel: function () {
            clearTimeout(this.intervalId);
        },
        tick: function (op, nextTick) {
            this.cancel();
            this.intervalId = setTimeout(op, nextTick);
        },
        store: function (result) {
            return result;
        },
        publishHeartbeat: function () {
            // placeholder unless implemented by child
        }
    };

    classifier(BaseHeartbeatItem);
    return BaseHeartbeatItem;
});
